<template>
  <div class="child-view">
    <div class="account-iframe__wrapper">
      <iframe
        class="account-iframe__object"
        :src="src"
        type="text/javascript"
        sandbox="allow-scripts allow-same-origin allow-downloads"
      ></iframe>
    </div>
    <a
      class="btn__back account-iframe__backbtn"
      href="#"
      @cancel="viewHistorial = false"
      @click="$emit('cancel')"
    >
      <span class="glicon-back-large-arrow"></span>
      <a @click="$router.go(-1)">{{ $t('actions.back') }}</a>
    </a>
  </div>
</template>

<script>
import config from '../../config.json';
import { mapState } from 'vuex';

export default {
  name: 'ClientCreditsRecord',
  data() {
    return {};
  },
  computed: {
    ...mapState({
      type: (state) => state.subscriptions.type,
      profileData: (state) => state.profile.profileData
    }),
    src() {
      const typedRoute = this.type === 'Credits' ? '/credits/clients/' : '/clients/subscriptions/';
      return `${config.accounts.lmsUrl}${typedRoute}${this.profileData.selectedClientId}?microfrontend=true`;
    }
  }
};
</script>
